var dropdownSlot = 'fx_2d2fb1e5_1sz44q60';

export { dropdownSlot };
//# sourceMappingURL=slot.vanilla.mjs.map
